import { put, takeLatest, take, race, cancel } from 'redux-saga/effects';
import * as cancelFamilyMemberInvitation from '../cancelFamilyMemberInvitation';
import * as cancelCaregiverInvitation from '../cancelCaregiverInvitation';
import * as cancelGuardianInvitation from '../cancel-guardian-invitation-req';
import * as circleOfCare from '../../board/circleOfCare';

function* cancelPendingInvitationWorker(action) {
  const {
    successCancelFamilyMemberInvite,
    successCancelCaregiverInvite,
    successCancelGuardianInvite,
  } = yield race({
    successCancelFamilyMemberInvite: take(
      cancelFamilyMemberInvitation.consts.SUCCEED,
    ),
    successCancelCaregiverInvite: take(
      cancelCaregiverInvitation.consts.SUCCEED,
    ),
    successCancelGuardianInvite: take(cancelGuardianInvitation.consts.SUCCEED),
  });

  const isInvitationSucceed =
    successCancelFamilyMemberInvite ||
    successCancelCaregiverInvite ||
    successCancelGuardianInvite;
  if (isInvitationSucceed)
    yield put(circleOfCare.actions.removeInvitation(action.payload));
}

export default function* cancelPendingInvitationSaga() {
  yield takeLatest(
    [
      cancelFamilyMemberInvitation.consts.SEND,
      cancelCaregiverInvitation.consts.SEND,
      cancelGuardianInvitation.consts.SEND,
    ],
    cancelPendingInvitationWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/circles/sagas/cancel-pending-invitation-saga.js